import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  nationalityList: [],
  loading: false,
  error: '',
};

export const fetchNationality = createAsyncThunk(
  'nationality/fetchNationality',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetNationality();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: item.name, //getLabel(item.nameAr, item.nameEn),
          value: item.id,
          key: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const nationalitySlice = createSlice({
  name: 'nationality',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNationality.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNationality.fulfilled, (state, action) => {
        state.loading = false;
        state.nationalityList = action.payload;
        state.error = '';
      })
      .addCase(fetchNationality.rejected, (state, action) => {
        state.loading = false;
        state.nationalityList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default nationalitySlice.reducer;
